/**
 *
 */
export default function () {
  return {
    /** @type {{id: string, name: string }} Пользователь */
    user: { id: '', name: '' },
    /** @type {number} Номер оператора */
    operator: null,
    /** @type {number} Номер оператора без CSAT */
    operator2: null,
    /** @type {string} Текущий статус оператора */
    operatorStatus: null,
    /** @type {string} Подпись в письме */
    signature: '',
    /** @type {string} Email в письме */
    emailFrom: '',
    /** @type {string} Имя в письме */
    emailFromName: '',
    /** @type {Array} Группы */
    groups: [],
    /** @type {object} Доступные провайдеры */
    providers: {},
    /** @type {{name: string}} Связанный сотрудник */
    orgStructure: { name: '' },
    /** @type {object} Статусы операторов */
    status: {},
    /** @type {string} Состояние соединения с БД */
    connection: 'offline',
    /** @type {number} Текущий запрос */
    currentIssue: null,
    /** @type {number} Точка текущего запроса */
    currentIssuePosId: null,
    /** Статус текущего запроса */
    currentIssueOpen: null,
    /** @type {Array} Точки синхронизации доступные пользователю */
    ts: [],
    /** @type {Array} Статусы заказа */
    orderStatuses: []
  }
}
